import { Injectable } from '@angular/core';
import { Buffer } from 'buffer';
import { from } from 'rxjs';
import { SnackMessageService } from './snackMessage.service';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  times: number[] = [];

  constructor(private snackMessageService: SnackMessageService) {}

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  public calculateRemainingTime(expirationDate): {
    days: number;
    months: number;
    years: number;
  } {
    let monthsRemaining = {
      days: 0,
      months: 0,
      years: 0
    };
    const expDate = new Date(expirationDate);
    const currentDate = new Date();

    if (expDate >= currentDate) {
      monthsRemaining = this.monthsBetween(currentDate, expDate);
    }
    return monthsRemaining;
  }

  checkLicenseProgress(infoTierUsed, tierTotal) {
    const keyMapping = {
      nodes: 'maxDevices',
      users: 'maxUsers',
      workloads: 'maxWorkloads',
      marketAppStandard: 'maxWorkloadsMarket'
    };
    let licenseLimits = {
      nearLimit: false,
      overLimit: false
    };
    for (const [usedKey, usedValueRaw] of Object.entries(infoTierUsed)) {
      const totalKey = keyMapping[usedKey];

      if (totalKey && tierTotal[totalKey] !== undefined) {
        const usedValue = Number(usedValueRaw);
        const totalValue = Number(tierTotal[totalKey]);
        const percentage = (usedValue / totalValue) * 100;

        if (percentage >= 100) {
          licenseLimits.overLimit = true;
        } else if (percentage > 80) {
          licenseLimits.nearLimit = true;
        }
        if (percentage === Infinity) {
          licenseLimits.overLimit = false;
        }
      }
    }
    return licenseLimits;
  }

  monthsBetween(currentDate: Date, expDate: Date) {
    let yearsDiff = expDate.getUTCFullYear() - currentDate.getUTCFullYear();
    let monthsDiff = expDate.getUTCMonth() - currentDate.getUTCMonth();
    let daysDiff = expDate.getUTCDate() - currentDate.getUTCDate();

    if (daysDiff >= 0) {
      daysDiff += 1;
    } else {
      const prevMonth = new Date(expDate.getUTCFullYear(), expDate.getUTCMonth(), 0);
      daysDiff += prevMonth.getUTCDate() + 1;
      monthsDiff -= 1;
    }
    if (monthsDiff < 0) {
      monthsDiff += 12;
      yearsDiff -= 1;
    }
    if (monthsDiff >= 12) {
      const extraYears = Math.floor(monthsDiff / 12);
      yearsDiff += extraYears;
      monthsDiff -= extraYears * 12;
    }

    return { years: yearsDiff, months: monthsDiff, days: daysDiff };
  }

  prepareCards(width) {
    switch (true) {
      case width > 320 && width <= 580:
        this.times = [1];
        break;
      case width > 580 && width <= 1023:
        this.times = [1, 2];
        break;
      case width > 1023 && width <= 1280:
        this.times = [1, 2, 3];
        break;
      case width > 1280 && width <= 1440:
        this.times = [1, 2, 3];
        break;
      case width > 1440 && width <= 1730:
        this.times = [1, 2, 3, 4];
        break;
      case width > 1730 && width <= 1920:
        this.times = [1, 2, 3, 4];
        break;
      case width > 1920 && width <= 2660:
        this.times = [1, 2, 3, 4, 5];
        break;
      case width >= 2660:
        this.times = [1, 2, 3, 4, 5, 6];
        break;
      default:
        this.times = [];
        break;
    }
    return this.times;
  }

  randomNumber(data, numberRandom, maxNumberRandom?) {
    if (maxNumberRandom === undefined) {
      maxNumberRandom = 4;
    }
    const max = data.length - 1;
    const min = 0;
    for (var i = 0; numberRandom.length < maxNumberRandom; i++) {
      let select = Math.floor(Math.random() * (max - min) + min);
      if (numberRandom.includes(select)) {
        select = Math.floor(Math.random() * (max - min) + min);
      } else {
        numberRandom.push(select);
      }
    }
    return numberRandom;
  }

  conversorString(texto: any) {
    return Buffer.from(texto, 'base64').toString();
  }

  conversorNumberBase64(texto: any) {
    return Buffer.from(texto, 'base64');
  }

  autoGrowTextArea(textarea: any) {
    textarea.target.style.height = '0px';
    textarea.target.style.height = textarea.target.scrollHeight + 25 + 'px';
  }

  conversorBase64(texto: any) {
    return Buffer.from(texto).toString('base64');
  }

  removeSpacesAndInsertScript(string) {
    return string.replace(/[\s_.]/g, '-');
  }

  copyToClipBoard(value) {
    from(navigator.clipboard.writeText(value)).subscribe((res) => {
      this.snackMessageService.sendMessage('Value copied to clipboard');
    });
  }

  // Antes filtraba además por !isPublic, pero tras el nuevo modelo la
  // visibilidad pública vive en las landings — toda app habilitada se
  // muestra en la home privada.
  filterCategoryApplicationsPrivateAndEnabled(categoryApplicationsList) {
    let _enabledApps = [];
    categoryApplicationsList.forEach((application) => {
      if (application.enabled) {
        _enabledApps.push(application);
      }
    });
    return _enabledApps;
  }

  addTagsList(appsList) {
    let _appsList = [];
    appsList.forEach((app, index) => {
      _appsList.push(app);
      let _dataTagsList = [];
      if (app.categories.find((category) => category.type === 3) !== undefined) {
        if (!_dataTagsList.includes('Best Seller')) {
          _dataTagsList.push('Best Seller');
        }
      }
      if (app.categories.find((category) => category.type === 2) !== undefined) {
        if (!_dataTagsList.includes('In library')) {
          _dataTagsList.push('In library');
        }
      }

      if (
        app.categories.find((category) => category.type === 4) !== undefined &&
        app.price !== undefined &&
        app.price.length > 0 &&
        app.price[0].value === 0
      ) {
        if (!_dataTagsList.includes('Free')) {
          _dataTagsList.push('Free');
        }
      }
      _appsList[index].dataTagList = _dataTagsList;
    });

    return _appsList;
  }

  public formatDateWithoutTime(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // Los meses empiezan desde 0
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }
}
